/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.IPage<defs.tms.CabinAdvanceMasterResponseDto>>;
export function request(
  params: API.tms.cabinAdvanceMaster.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/cabinAdvanceMaster/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
